import { ButtonGroup } from '@mui/material';
import { Datagrid, DateField, DeleteButton, EditButton, RichTextField, TextField } from 'react-admin';

export const ClientNoteDatagrid: React.FC = () => {
  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick="show"
      sx={{
        '& .RaDatagrid-rowCell > *': {
          display: 'block',
          minWidth: '100%',
        },
      }}
    >
      <TextField label="ID" source="id" width="3em" />
      <DateField label="Dátum aktualizácie" locales="sk" showTime={true} source="updateTimestamp" width={'6em'} />
      <RichTextField label="Poznámka" source="text" width="18em" />
      <ButtonGroup sx={{ textAlign: 'right', width: '12em' }}>
        <EditButton centerRipple={true} variant="text" />
        <DeleteButton mutationMode="pessimistic" redirect="" variant="text" />
      </ButtonGroup>
    </Datagrid>
  );
};
